<template>
  <v-card>
    <v-card-title class="toolbar white--text">
      <h3>Trades ({{ filteredItems.length }})</h3>
      <div
        v-if="selected.length > 0"
        class="ml-3"
      >
        <v-tooltip
          top
          dark
        >
          <template v-slot:activator="{ on }">
            <v-btn
              dark
              flat
              icon
              @click="approveModalOpen = true"
              v-on="on"
            >
              <v-icon>check</v-icon>
            </v-btn>
          </template>
          <span>Confirm Trade(s)</span>
        </v-tooltip>
      </div>
      <div
        v-if="selected.length > 0"
        class="ml-3"
      >
        <v-tooltip
          top
          dark
        >
          <template v-slot:activator="{ on }">
            <v-btn
              dark
              flat
              icon
              @click="cancelModalOpen = true"
              v-on="on"
            >
              <v-icon>cancel</v-icon>
            </v-btn>
          </template>
          <span>Cancel Trade(s)</span>
        </v-tooltip>
      </div>
      <v-spacer />
      <v-text-field
        v-model="search"
        primary
        dark
        solo-inverted
        flat
        append-icon="search"
        label="Search"
        single-line
        hide-details
      />
    </v-card-title>

    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="filteredItems"
      :pagination.sync="pagination"
      :rows-per-page-items="rowsPerPageItems"
      :search="search"
      :loading="loading"
      select-all
      item-key="id"
      class="elevation-1"
      @update:pagination="updatePagination"
    >
      <template
        slot="headers"
        slot-scope="props"
      >
        <tr>
          <th>
            <v-checkbox
              :input-value="props.all"
              :indeterminate="props.indeterminate"
              primary
              hide-details
              @click.native="toggleAll"
            />
          </th>
          <th
            v-for="header in props.headers"
            :key="header.text"
            :class="[
              'column sortable',
              pagination.descending ? 'desc' : 'asc',
              header.value === pagination.sortBy ? 'active' : ''
            ]"
            @click="changeSort(header.value)"
          >
            <v-icon small>
              arrow_upward
            </v-icon>
            {{ header.text }}
          </th>
        </tr>
      </template>
      <template
        slot="items"
        slot-scope="props"
      >
        <tr
          :active="props.selected"
          @click="toogleSelected(props)"
        >
          <td>
            <v-checkbox
              :input-value="props.selected"
              color="primary"
              hide-details
            />
          </td>
          <td class="text-xs-center">
            {{ props.item.id }}
          </td>
          <td class="text-xs-center">
            {{ centsToEuros(props.item.unit_price) }}
          </td>
          <td class="text-xs-center">
            {{ props.item.user_id }}
          </td>
          <td class="text-xs-center">
            {{ props.item.security_wallet }}
          </td>
          <td class="text-xs-center">
            {{ props.item.offer.user_id }}
          </td>
          <td class="text-xs-center">
            {{ props.item.offer.security_wallet }}
          </td>
          <td class="text-xs-center">
            {{ props.item.pieces }}
          </td>
          <td class="text-xs-center">
            {{ props.item.offer.asset.asset_id }}
          </td>
          <td class="text-xs-center">
            <v-tooltip
              top
              dark
            >
              <template v-slot:activator="{ on }">
                <v-chip
                  color="grey"
                  outline
                  small
                  v-on="on"
                >
                  <span>
                    {{ formatDateSmall(props.item.created_at) }}
                  </span>
                </v-chip>
              </template>
              {{ formatDate(props.item.created_at) }}
            </v-tooltip>
          </td>
          <td class="text-xs-center">
            <v-tooltip
              top
              dark
            >
              <template v-slot:activator="{ on }">
                <v-chip
                  color="grey"
                  outline
                  small
                  v-on="on"
                >
                  <span>
                    {{ formatDateSmall(props.item.updated_at) }}
                  </span>
                </v-chip>
              </template>
              {{ formatDate(props.item.updated_at) }}
            </v-tooltip>
          </td>
        </tr>
      </template>
    </v-data-table>

    <v-dialog
      v-model="approveModalOpen"
      width="600"
      persistent
    >
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Confirm Selected Trades
        </v-card-title>
        <v-card-text>
          Please confirm that the next ID(s) Trade(s) are already transferred:
          <strong>{{ selected.map(select=> select.id).join(', ') }}</strong>
        </v-card-text>

        <v-form
          ref="tradeForm"
          @submit.prevent="approveTrades"
        >
          <v-divider />

          <v-card-actions>
            <v-spacer />
            <v-btn
              flat
              @click="approveModalOpen = false"
            >
              Close
            </v-btn>
            <e-button
              flat
              type="submit"
              color="blue"
              text="Confirm Trades"
              :loading="loading"
              @click="approveModalOpen = true"
            />
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="cancelModalOpen"
      width="600"
      persistent
    >
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Cancel Selected Trades
        </v-card-title>
        <v-card-text>
          Please confirm that the next ID(s) Trade(s) could not be transferred:
          <strong>{{ selected.map(select=> select.id).join(', ') }}</strong>
        </v-card-text>

        <v-form
          ref="tradeForm"
          @submit.prevent="cancelTrades"
        >
          <v-divider />

          <v-card-actions>
            <v-spacer />
            <v-btn
              flat
              @click="cancelModalOpen = false"
            >
              Close
            </v-btn>
            <e-button
              flat
              type="submit"
              color="blue"
              text="Cancel Trades"
              :loading="loading"
            />
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex';
import { Button } from '@/components/shared';
import { setQuery } from '@/helpers';


export default {
  name: 'BlockchainPendingTradesTable',
  components: {
    'e-button': Button,
  },
  props: {
    bTrades: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      approveModalOpen: false,
      cancelModalOpen: false,
      isLoadTableData: false,
      search: '',
      selected: [],
      pagination: {
        page: 1,
        rowsPerPage: 25,
        totalItems: 0,
        sortBy: 'createdAt',
        descending: true,
      },
      rowsPerPageItems: [
        {
          text: '10',
          value: 10,
        },
        {
          text: '25',
          value: 25,
        },
        {
          text: '50',
          value: 50,
        },
        {
          text: 'All',
          value: -1,
        },
      ],
      filters: {
        createdAt: [],
      },
      headers: [
        {
          text: 'Trade Id',
          align: 'left',
          value: 'id',
        },
        {
          text: 'Unit Price',
          align: 'left',
          value: 'unit_price',
        },
        {
          text: 'Trader User Id',
          align: 'left',
          value: 'user_id',
        },
        {
          text: 'Trader wallet',
          align: 'left',
          value: 'security_wallet',
        },
        {
          text: 'Seller User Id',
          align: 'left',
          value: 'offer.user_id',
        },
        {
          text: 'Seller wallet',
          align: 'left',
          value: 'offer.security_wallet',
        },
        {
          text: 'Pieces',
          align: 'left',
          value: 'pieces',
        },
        {
          text: 'Blockchain asset id',
          align: 'left',
          value: 'offer.asset.asset_id',
        },
        {
          text: 'Created at',
          value: 'created_at',
        },
        {
          text: 'Updated at',
          value: 'updated_at',
        },
      ],
    };
  },
  computed: {
    filteredItems() {
      return this.bTrades.filter(d => Object.keys(this.filters).every((f) => {
        if (this.filters[f]) {
          return (
            this.filters[f].length < 1 ||
            String(this.filters[f]).includes(d[f])
          );
        }

        return true;
      }));
    },
  },
  watch: {
    async bTrades() {
      this.getDefaultFilters();
      await this.$nextTick();
      await this.changePage();
    },
    search(val) {
      setQuery(
        {
          search: val,
        },
        this.$route,
        this.$router,
      );
    },
  },
  methods: {
    ...mapActions(['getbTrades', 'approveBPendingTrades', 'cancelBPendingTrades']),
    formatDate(date) {
      return this.$moment(date).format('MMMM Do YYYY, h:mm:ss a');
    },
    formatDateSmall(date) {
      return this.$moment(date).format('DD/MM/YYYY');
    },
    centsToEuros(amount) {
      amount = `${parseInt(amount, 0) / 100}`;

      return `${parseFloat(amount).toFixed(2)} €`;
    },
    toggleAll() {
      if (this.selected.length) {
        this.selected = [];
      } else {
        this.selected = this.bTrades.slice();
      }
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    updatePagination(pagination) {
      if (this.isLoadTableData) {
        setQuery(
          {
            page: pagination.page,
          },
          this.$route,
          this.$router,
        );
      }
    },
    toogleSelected(props) {
      props.selected = !props.selected;
    },
    async changePage() {
      const { page, search } = this.$route.query;
      this.search = search;
      await this.$nextTick();
      this.isLoadTableData = true;
      this.pagination.page = page ? Number(page) : 1;
    },
    getDefaultFilters() {
      if (this.$route.query) {
        Object.keys(this.$route.query).forEach((item) => {
          let value = this.$route.query[item];

          if (Object.prototype.hasOwnProperty.call(this.filters, item)) {
            if (typeof this.filters[item] === 'string') {
              this.filters[item] = value;
            } else if (String(this.$route.query[item]).includes(';')) {
              value = this.$route.query[item].split(';');
              this.filters[item] = value;
            } else {
              this.filters[item].push(value);
            }
          }
        });
      }
    },
    async approveTrades() {
      const data = { ids: this.selected.map(v => v.id) };
      await this.approveBPendingTrades(data);
      this.approveModalOpen = false;
      this.selected = [];
    },
    async cancelTrades() {
      const data = { ids: this.selected.map(v => v.id) };

      await this.cancelBPendingTrades(data);
      this.cancelModalOpen = false;
      this.selected = [];
    },
  },
};
</script>

<style lang="scss" scoped>
a {
  text-decoration: none;
  color: black;
}

.toolbar {
  background-color: #1a4c7d;
  color: white;
}

.infoLabel {
  margin-left: 16px;
}

.countLabel {
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/trades/BlockchainPendingTradesTable.vue